import { render, staticRenderFns } from "./index.vue?vue&type=template&id=67e9807a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./_index.scss?vue&type=style&index=0&id=67e9807a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e9807a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconsApp: require('/opt/components/icons/App.vue').default})
